module.exports = __webpack_public_path__ + "img/emoji/hng.6f8f6b61ad27c0f5f40ab828b43300d2.png";